import { useState } from "react";
import { createAdmin } from "../../../services/met/Service";

function ContentAddNewUser() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.firstName) newErrors.firstName = "First name is required";
    if (!formData.lastName) newErrors.lastName = "Last name is required";

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Enter valid 10 digit number";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setLoading(true);

      const response = await createAdmin(formData);

      if (response.data.code === 200) {
        setSuccessMessage("Admin created successfully");

        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
        });
      } else {
        setErrorMessage(response.data.message || "Something went wrong");
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrorMessage("API error");
      console.error(error);
    }
  };

  const handleClear = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    });
    setErrors({});
    setErrorMessage("");
    setSuccessMessage("");
  };

  return (
    <section className="ContentUserManagement">
      <div className="container-fluid px-0">
        <h4 className="mb-3">Add Admin</h4>

        {successMessage && (
          <div className="text-success mb-2">{successMessage}</div>
        )}
        {errorMessage && (
          <div className="text-danger mb-2">{errorMessage}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="row">

            <div className="col-md-6 mb-3">
              <label className="form-label">First Name *</label>
              <input
                type="text"
                name="firstName"
                className="form-control input-field-ui"
                value={formData.firstName}
                onChange={handleChange}
              />
              {errors.firstName && (
                <div className="text-danger">{errors.firstName}</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Last Name *</label>
              <input
                type="text"
                name="lastName"
                className="form-control input-field-ui"
                value={formData.lastName}
                onChange={handleChange}
              />
              {errors.lastName && (
                <div className="text-danger">{errors.lastName}</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Email *</label>
              <input
                type="text"
                name="email"
                className="form-control input-field-ui"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && (
                <div className="text-danger">{errors.email}</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Phone Number *</label>
              <input
                type="text"
                name="phoneNumber"
                className="form-control input-field-ui"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
              {errors.phoneNumber && (
                <div className="text-danger">{errors.phoneNumber}</div>
              )}
            </div>

            <div className="col-md-12">
              <button
                type="submit"
                className="btn btn-primary btn-primary program-save-btn me-2"
                disabled={loading}
              >
                {loading ? "Saving..." : "Add Admin"}
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClear}
              >
                Clear
              </button>
            </div>

          </div>
        </form>
      </div>
    </section>
  );
}

export default ContentAddNewUser;